export enum EntityRole {
  BorrowerRole = 'BorrowerRole',
  LenderRole = 'LenderRole',
  LetterOfCreditRole = 'LetterOfCreditRole',
  GuarantorRole = 'GuarantorRole',
  ThirdPartyRole = 'ThirdPartyRole',
  AdminAgentRole = 'AdminAgentRole',
  CustodianRole = 'CustodianRole',
  TrusteeRole = 'TrusteeRole',
  ServicerRole = 'ServicerRole',
  BusinessProcessOutsourcerRole = 'BusinessProcessOutsourcerRole',
  FundAdminRole = 'FundAdminRole',
  FundManagerParentRole = 'FundManagerParentRole',
  PrincipalRole = 'PrincipalRole',
  SecurityAgentRole = 'SecurityAgentRole',
  LegalRole = 'LegalRole',
  FundSubaccountRole = 'FundSubaccountRole',
}

export enum ThirdPartyRoles {
  CustodianRole = 'CustodianRole',
  TrusteeRole = 'TrusteeRole',
  BusinessProcessOutsourcerRole = 'BusinessProcessOutsourcerRole',
  FundAdminRole = 'FundAdminRole',
  LegalRole = 'LegalRole',
  // Open Trade Packet recipients: the only role pulled for the Agent Open
  // Trade EML, excluded from the Settlement Packet (ADR_LOS-026).
  AgentRole = 'AgentRole',
}

export type EntityProfileParams = {
  id?: string
  name: string
  isExternalUser: boolean
  isMyCompany: boolean
  kycType: string
  roles: EntityRole[]
  isActive: boolean
  agencyAdmin?: string
  observers?: string[]
}
